import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, inject, input } from '@angular/core';
import { CheckIcon } from 'prime-ng-old/icons/check';
import { ChevronDownIcon } from 'prime-ng-old/icons/chevrondown';
import { ChevronRightIcon } from 'prime-ng-old/icons/chevronright';
import { MinusIcon } from 'prime-ng-old/icons/minus';
import { PlusIcon } from 'prime-ng-old/icons/plus';
import { Tree as TreeBase, UITreeNode as UITreeNodeBase } from 'prime-ng-old/tree';
import { ScrollerModule } from 'prime-ng-old/scroller';
import { UiHeaderFooterBundle } from '../shared';
import { UiIconComponent } from '../icons';
import { PARENT_TREE } from './tree.injection-token';
import { getTreeNodePath, deepFindTreeNodeBy, getPathToMatchingTreeNode } from './tree.utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "prime-ng-old/scroller";
import * as i3 from "primeng/api";
const _c0 = a0 => ({
  "p-treenode-droppoint-active": a0
});
const _c1 = (a0, a1) => ["p-treenode", a0, a1];
const _c2 = a0 => ({
  height: a0
});
const _c3 = (a0, a1, a2) => ({
  "p-treenode-selectable": a0,
  "p-treenode-dragover": a1,
  "p-highlight": a2
});
const _c4 = a0 => ({
  "p-checkbox-disabled p-disabled": a0
});
const _c5 = (a0, a1) => ({
  "p-highlight": a0,
  "p-indeterminate": a1
});
const _c6 = a0 => ({
  $implicit: a0
});
const _c7 = a0 => ({
  "p-treenode-collapsed": a0
});
const _c8 = (a0, a1) => ({
  "p-treenode-selectable": a0,
  "p-highlight": a1
});
const _c9 = a0 => ({
  "p-treenode-connector-line": a0
});
function _forTrack0($index, $item) {
  return this.tree.trackBy($index, $item);
}
function UiTreeNode_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 3);
    i0.ɵɵlistener("drop", function UiTreeNode_Conditional_0_Conditional_0_Template_li_drop_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropPoint($event, -1));
    })("dragover", function UiTreeNode_Conditional_0_Conditional_0_Template_li_dragover_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropPointDragOver($event));
    })("dragenter", function UiTreeNode_Conditional_0_Conditional_0_Template_li_dragenter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropPointDragEnter($event, -1));
    })("dragleave", function UiTreeNode_Conditional_0_Conditional_0_Template_li_dragleave_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropPointDragLeave($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r1.draghoverPrev));
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronRightIcon", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-tree-toggler-icon");
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ChevronDownIcon", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-tree-toggler-icon");
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "CheckIcon", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-checkbox-icon");
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_5_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "MinusIcon", 7);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-checkbox-icon");
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 12);
    i0.ɵɵconditionalCreate(2, UiTreeNode_Conditional_0_Conditional_1_Conditional_5_Conditional_2_Template, 1, 1, "CheckIcon", 7);
    i0.ɵɵconditionalCreate(3, UiTreeNode_Conditional_0_Conditional_1_Conditional_5_Conditional_3_Template, 1, 1, "MinusIcon", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c4, ctx_r1.node.selectable === false));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c5, ctx_r1.isSelected(), ctx_r1.node.partialSelected));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.node.partialSelected && ctx_r1.isSelected() ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.node.partialSelected ? 3 : -1);
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("icon", ctx_r1.getIcon());
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.node.label);
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_9_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, UiTreeNode_Conditional_0_Conditional_1_Conditional_9_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.tree.getTemplateForNode(ctx_r1.node))("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, ctx_r1.node));
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_10_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-tree-node", 15);
  }
  if (rf & 2) {
    const childNode_r4 = ctx.$implicit;
    const ɵ$index_48_r5 = ctx.$index;
    const ɵ$count_48_r6 = ctx.$count;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("node", childNode_r4)("parentNode", ctx_r1.node)("firstChild", ɵ$index_48_r5 === 0)("lastChild", ɵ$index_48_r5 === ɵ$count_48_r6 - 1)("index", ɵ$index_48_r5)("itemSize", ctx_r1.itemSize)("level", ctx_r1.level + 1);
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 14);
    i0.ɵɵrepeaterCreate(1, UiTreeNode_Conditional_0_Conditional_1_Conditional_10_For_2_Template, 1, 7, "ui-tree-node", 15, _forTrack0, true);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("display", ctx_r1.node.expanded ? "block" : "none");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.node.children);
  }
}
function UiTreeNode_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 4);
    i0.ɵɵlistener("keydown", function UiTreeNode_Conditional_0_Conditional_1_Template_li_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onKeyDown($event));
    });
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵlistener("click", function UiTreeNode_Conditional_0_Conditional_1_Template_div_click_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNodeClick($event));
    })("contextmenu", function UiTreeNode_Conditional_0_Conditional_1_Template_div_contextmenu_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNodeRightClick($event));
    })("touchend", function UiTreeNode_Conditional_0_Conditional_1_Template_div_touchend_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNodeTouchEnd());
    })("drop", function UiTreeNode_Conditional_0_Conditional_1_Template_div_drop_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropNode($event));
    })("dragover", function UiTreeNode_Conditional_0_Conditional_1_Template_div_dragover_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropNodeDragOver($event));
    })("dragenter", function UiTreeNode_Conditional_0_Conditional_1_Template_div_dragenter_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropNodeDragEnter($event));
    })("dragleave", function UiTreeNode_Conditional_0_Conditional_1_Template_div_dragleave_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropNodeDragLeave($event));
    })("dragstart", function UiTreeNode_Conditional_0_Conditional_1_Template_div_dragstart_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDragStart($event));
    })("dragend", function UiTreeNode_Conditional_0_Conditional_1_Template_div_dragend_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDragStop($event));
    });
    i0.ɵɵelementStart(2, "button", 6);
    i0.ɵɵlistener("click", function UiTreeNode_Conditional_0_Conditional_1_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggle($event));
    });
    i0.ɵɵconditionalCreate(3, UiTreeNode_Conditional_0_Conditional_1_Conditional_3_Template, 1, 1, "ChevronRightIcon", 7);
    i0.ɵɵconditionalCreate(4, UiTreeNode_Conditional_0_Conditional_1_Conditional_4_Template, 1, 1, "ChevronDownIcon", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(5, UiTreeNode_Conditional_0_Conditional_1_Conditional_5_Template, 4, 9, "div", 8);
    i0.ɵɵconditionalCreate(6, UiTreeNode_Conditional_0_Conditional_1_Conditional_6_Template, 1, 1, "ui-icon", 9);
    i0.ɵɵelementStart(7, "span", 10);
    i0.ɵɵconditionalCreate(8, UiTreeNode_Conditional_0_Conditional_1_Conditional_8_Template, 2, 1, "span");
    i0.ɵɵconditionalCreate(9, UiTreeNode_Conditional_0_Conditional_1_Conditional_9_Template, 2, 4, "span");
    i0.ɵɵelementEnd()();
    i0.ɵɵconditionalCreate(10, UiTreeNode_Conditional_0_Conditional_1_Conditional_10_Template, 3, 2, "ul", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(ctx_r1.node.style);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(24, _c1, ctx_r1.node.styleClass || "", ctx_r1.isLeaf() ? "p-treenode-leaf" : ""))("ngStyle", i0.ɵɵpureFunction1(27, _c2, ctx_r1.itemSize + "px"));
    i0.ɵɵattribute("aria-label", ctx_r1.node.label)("aria-checked", ctx_r1.ariaChecked)("aria-setsize", ctx_r1.node.children ? ctx_r1.node.children.length : 0)("aria-selected", ctx_r1.ariaSelected)("aria-expanded", ctx_r1.node.expanded)("aria-posinset", ctx_r1.index + 1)("aria-level", ctx_r1.level)("tabindex", ctx_r1.index === 0 ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("padding-left", ctx_r1.level * ctx_r1.indentation + "rem");
    i0.ɵɵproperty("draggable", ctx_r1.tree.draggableNodes)("ngClass", i0.ɵɵpureFunction3(29, _c3, ctx_r1.tree.selectionMode && ctx_r1.node.selectable !== false, ctx_r1.draghoverNode, ctx_r1.isSelected()));
    i0.ɵɵadvance();
    i0.ɵɵattribute("data-pc-section", "toggler");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.node.expanded ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.node.expanded ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tree.selectionMode == "checkbox" ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.node.icon || ctx_r1.node.expandedIcon || ctx_r1.node.collapsedIcon ? 6 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.tree.getTemplateForNode(ctx_r1.node) ? 8 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tree.getTemplateForNode(ctx_r1.node) ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.tree.virtualScroll && ctx_r1.node.children && ctx_r1.node.expanded ? 10 : -1);
  }
}
function UiTreeNode_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 3);
    i0.ɵɵlistener("drop", function UiTreeNode_Conditional_0_Conditional_2_Template_li_drop_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropPoint($event, 1));
    })("dragover", function UiTreeNode_Conditional_0_Conditional_2_Template_li_dragover_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropPointDragOver($event));
    })("dragenter", function UiTreeNode_Conditional_0_Conditional_2_Template_li_dragenter_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropPointDragEnter($event, 1));
    })("dragleave", function UiTreeNode_Conditional_0_Conditional_2_Template_li_dragleave_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onDropPointDragLeave($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r1.draghoverNext));
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 16)(1, "table", 21)(2, "tbody")(3, "tr");
    i0.ɵɵelement(4, "td", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "tr");
    i0.ɵɵelement(6, "td", 19);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c9, !ctx_r1.firstChild));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c9, !ctx_r1.lastChild));
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "PlusIcon", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("styleClass", "p-tree-toggler-icon")("ariaLabel", ctx_r1.tree.togglerAriaLabel);
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "MinusIcon", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("styleClass", "p-tree-toggler-icon")("ariaLabel", ctx_r1.tree.togglerAriaLabel);
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵlistener("click", function UiTreeNode_Conditional_0_Conditional_3_Conditional_6_Template_span_click_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.toggle($event));
    });
    i0.ɵɵconditionalCreate(1, UiTreeNode_Conditional_0_Conditional_3_Conditional_6_Conditional_1_Template, 1, 2, "PlusIcon", 23);
    i0.ɵɵconditionalCreate(2, UiTreeNode_Conditional_0_Conditional_3_Conditional_6_Conditional_2_Template, 1, 2, "MinusIcon", 23);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", "p-tree-toggler");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.node.expanded ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.node.expanded ? 2 : -1);
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r1.getIcon());
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.node.label);
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, UiTreeNode_Conditional_0_Conditional_3_Conditional_10_ng_container_1_Template, 1, 0, "ng-container", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.tree.getTemplateForNode(ctx_r1.node))("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, ctx_r1.node));
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_11_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-treeNode", 26);
  }
  if (rf & 2) {
    const childNode_r10 = ctx.$implicit;
    const ɵ$index_110_r11 = ctx.$index;
    const ɵ$count_110_r12 = ctx.$count;
    i0.ɵɵproperty("node", childNode_r10)("firstChild", ɵ$index_110_r11 === 0)("lastChild", ɵ$index_110_r11 === ɵ$count_110_r12 - 1);
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 24)(1, "div", 25);
    i0.ɵɵrepeaterCreate(2, UiTreeNode_Conditional_0_Conditional_3_Conditional_11_For_3_Template, 1, 3, "p-treeNode", 26, _forTrack0, true);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleProp("display", ctx_r1.node.expanded ? "table-cell" : "none");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.node.children);
  }
}
function UiTreeNode_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table")(1, "tbody")(2, "tr");
    i0.ɵɵconditionalCreate(3, UiTreeNode_Conditional_0_Conditional_3_Conditional_3_Template, 7, 6, "td", 16);
    i0.ɵɵelementStart(4, "td", 17)(5, "div", 18);
    i0.ɵɵlistener("click", function UiTreeNode_Conditional_0_Conditional_3_Template_div_click_5_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNodeClick($event));
    })("contextmenu", function UiTreeNode_Conditional_0_Conditional_3_Template_div_contextmenu_5_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNodeRightClick($event));
    })("touchend", function UiTreeNode_Conditional_0_Conditional_3_Template_div_touchend_5_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNodeTouchEnd());
    })("keydown", function UiTreeNode_Conditional_0_Conditional_3_Template_div_keydown_5_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onNodeKeydown($event));
    });
    i0.ɵɵconditionalCreate(6, UiTreeNode_Conditional_0_Conditional_3_Conditional_6_Template, 3, 3, "span", 19);
    i0.ɵɵconditionalCreate(7, UiTreeNode_Conditional_0_Conditional_3_Conditional_7_Template, 1, 2, "span", 2);
    i0.ɵɵelementStart(8, "span", 10);
    i0.ɵɵconditionalCreate(9, UiTreeNode_Conditional_0_Conditional_3_Conditional_9_Template, 2, 1, "span");
    i0.ɵɵconditionalCreate(10, UiTreeNode_Conditional_0_Conditional_3_Conditional_10_Template, 2, 4, "span");
    i0.ɵɵelementEnd()()();
    i0.ɵɵconditionalCreate(11, UiTreeNode_Conditional_0_Conditional_3_Conditional_11_Template, 4, 2, "td", 20);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.node.styleClass);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(!ctx_r1.root ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c7, !ctx_r1.node.expanded));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(12, _c8, ctx_r1.tree.selectionMode, ctx_r1.isSelected()));
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isLeaf() ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.node.icon || ctx_r1.node.expandedIcon || ctx_r1.node.collapsedIcon ? 7 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.tree.getTemplateForNode(ctx_r1.node) ? 9 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tree.getTemplateForNode(ctx_r1.node) ? 10 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.node.children && ctx_r1.node.expanded ? 11 : -1);
  }
}
function UiTreeNode_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTreeNode_Conditional_0_Conditional_0_Template, 1, 3, "li", 0);
    i0.ɵɵconditionalCreate(1, UiTreeNode_Conditional_0_Conditional_1_Template, 11, 33, "li", 1);
    i0.ɵɵconditionalCreate(2, UiTreeNode_Conditional_0_Conditional_2_Template, 1, 3, "li", 0);
    i0.ɵɵconditionalCreate(3, UiTreeNode_Conditional_0_Conditional_3_Template, 12, 15, "table", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.tree.droppableNodes ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.tree.horizontal ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tree.droppableNodes && ctx_r1.lastChild ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.tree.horizontal ? 3 : -1);
  }
}
const _c10 = (a0, a1, a2, a3) => ({
  "p-tree p-component": true,
  "p-tree-selectable": a0,
  "p-treenode-dragover": a1,
  "p-tree-loading": a2,
  "p-tree-flex-scrollable": a3
});
const _c11 = a0 => ({
  options: a0
});
const _c12 = a0 => ({
  "p-tree p-tree-horizontal p-component": true,
  "p-tree-selectable": a0
});
function UiTreeComponent_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("p-tree-loading-icon pi-spin " + ctx_r1.loadingIcon);
  }
}
function UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SpinnerIcon", 14);
  }
  if (rf & 2) {
    i0.ɵɵproperty("spin", true)("styleClass", "p-tree-loading-icon");
  }
}
function UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_1_ng_template_0_Template(rf, ctx) {}
function UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtemplate(1, UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_1_Template, 1, 0, null, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.loadingIconTemplate);
  }
}
function UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_0_Template, 1, 2, "SpinnerIcon", 14);
    i0.ɵɵconditionalCreate(1, UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Template, 2, 1, "span", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(!ctx_r1.loadingIconTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loadingIconTemplate ? 1 : -1);
  }
}
function UiTreeComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵconditionalCreate(1, UiTreeComponent_Conditional_0_Conditional_1_Conditional_1_Template, 1, 2, "i", 13);
    i0.ɵɵconditionalCreate(2, UiTreeComponent_Conditional_0_Conditional_1_Conditional_2_Template, 2, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loadingIcon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.loadingIcon ? 2 : -1);
  }
}
function UiTreeComponent_Conditional_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTreeComponent_Conditional_0_Conditional_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SearchIcon", 17);
  }
  if (rf & 2) {
    i0.ɵɵproperty("styleClass", "p-tree-filter-icon");
  }
}
function UiTreeComponent_Conditional_0_Conditional_3_Conditional_4_1_ng_template_0_Template(rf, ctx) {}
function UiTreeComponent_Conditional_0_Conditional_3_Conditional_4_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTreeComponent_Conditional_0_Conditional_3_Conditional_4_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTreeComponent_Conditional_0_Conditional_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtemplate(1, UiTreeComponent_Conditional_0_Conditional_3_Conditional_4_1_Template, 1, 0, null, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.filterIconTemplate);
  }
}
function UiTreeComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "input", 16, 0);
    i0.ɵɵlistener("keydown.enter", function UiTreeComponent_Conditional_0_Conditional_3_Template_input_keydown_enter_1_listener($event) {
      return $event.preventDefault();
    })("input", function UiTreeComponent_Conditional_0_Conditional_3_Template_input_input_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1._filter($event.target.value));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, UiTreeComponent_Conditional_0_Conditional_3_Conditional_3_Template, 1, 1, "SearchIcon", 17);
    i0.ɵɵconditionalCreate(4, UiTreeComponent_Conditional_0_Conditional_3_Conditional_4_Template, 2, 1, "span", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("placeholder", ctx_r1.filterPlaceholder);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.filterIconTemplate ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.filterIconTemplate ? 4 : -1);
  }
}
function UiTreeComponent_Conditional_0_Conditional_4_ng_template_2_Conditional_0_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-tree-node", 24, 2);
  }
  if (rf & 2) {
    const rowNode_r5 = ctx.$implicit;
    const ɵ$index_48_r6 = ctx.$index;
    const ɵ$count_48_r7 = ctx.$count;
    const scrollerOptions_r8 = i0.ɵɵnextContext(2).options;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("level", rowNode_r5.level)("rowNode", rowNode_r5)("node", rowNode_r5.node)("firstChild", ɵ$index_48_r6 === 0)("lastChild", ɵ$index_48_r6 === ɵ$count_48_r7 - 1)("index", ctx_r1.getIndex(scrollerOptions_r8, ɵ$index_48_r6))("itemSize", scrollerOptions_r8.itemSize)("indentation", ctx_r1.indentation);
  }
}
function UiTreeComponent_Conditional_0_Conditional_4_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 23);
    i0.ɵɵrepeaterCreate(1, UiTreeComponent_Conditional_0_Conditional_4_ng_template_2_Conditional_0_For_2_Template, 2, 8, "ui-tree-node", 24, i0.ɵɵcomponentInstance().trackBy, true);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const items_r10 = ctx_r8.$implicit;
    const scrollerOptions_r8 = ctx_r8.options;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵstyleMap(scrollerOptions_r8.contentStyle);
    i0.ɵɵproperty("ngClass", scrollerOptions_r8.contentStyleClass);
    i0.ɵɵattribute("aria-label", ctx_r1.ariaLabel)("aria-labelledby", ctx_r1.ariaLabelledBy);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(items_r10);
  }
}
function UiTreeComponent_Conditional_0_Conditional_4_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTreeComponent_Conditional_0_Conditional_4_ng_template_2_Conditional_0_Template, 3, 5, "ul", 22);
  }
  if (rf & 2) {
    const items_r10 = ctx.$implicit;
    i0.ɵɵconditional(items_r10 ? 0 : -1);
  }
}
function UiTreeComponent_Conditional_0_Conditional_4_Conditional_3_ng_template_0_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTreeComponent_Conditional_0_Conditional_4_Conditional_3_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTreeComponent_Conditional_0_Conditional_4_Conditional_3_ng_template_0_ng_container_0_Template, 1, 0, "ng-container", 25);
  }
  if (rf & 2) {
    const scrollerOptions_r11 = ctx.options;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.loaderTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c11, scrollerOptions_r11));
  }
}
function UiTreeComponent_Conditional_0_Conditional_4_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTreeComponent_Conditional_0_Conditional_4_Conditional_3_ng_template_0_Template, 1, 4, "ng-template", 21);
  }
}
function UiTreeComponent_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-scroller", 19, 1);
    i0.ɵɵlistener("onScroll", function UiTreeComponent_Conditional_0_Conditional_4_Template_p_scroller_onScroll_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onScroll.emit($event));
    })("onScrollIndexChange", function UiTreeComponent_Conditional_0_Conditional_4_Template_p_scroller_onScrollIndexChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onScrollIndexChange.emit($event));
    })("onLazyLoad", function UiTreeComponent_Conditional_0_Conditional_4_Template_p_scroller_onLazyLoad_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onLazyLoad.emit($event));
    });
    i0.ɵɵtemplate(2, UiTreeComponent_Conditional_0_Conditional_4_ng_template_2_Template, 1, 1, "ng-template", 20);
    i0.ɵɵconditionalCreate(3, UiTreeComponent_Conditional_0_Conditional_4_Conditional_3_Template, 1, 0, null, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(9, _c2, ctx_r1.scrollHeight !== "flex" ? ctx_r1.scrollHeight : undefined));
    i0.ɵɵproperty("items", ctx_r1.serializedValue)("tabindex", -1)("scrollHeight", ctx_r1.scrollHeight !== "flex" ? undefined : "100%")("itemSize", ctx_r1.virtualScrollItemSize || ctx_r1._virtualNodeHeight)("lazy", ctx_r1.lazy)("options", ctx_r1.virtualScrollOptions);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.loaderTemplate ? 3 : -1);
  }
}
function UiTreeComponent_Conditional_0_Conditional_5_Conditional_2_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-tree-node", 28);
  }
  if (rf & 2) {
    const node_r12 = ctx.$implicit;
    const ɵ$index_64_r13 = ctx.$index;
    const ɵ$count_64_r14 = ctx.$count;
    i0.ɵɵproperty("node", node_r12)("firstChild", ɵ$index_64_r13 === 0)("lastChild", ɵ$index_64_r13 === ɵ$count_64_r14 - 1)("index", ɵ$index_64_r13)("level", 0);
  }
}
function UiTreeComponent_Conditional_0_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 27);
    i0.ɵɵrepeaterCreate(1, UiTreeComponent_Conditional_0_Conditional_5_Conditional_2_For_2_Template, 1, 5, "ui-tree-node", 28, i0.ɵɵcomponentInstance().trackBy, true);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("aria-label", ctx_r1.ariaLabel)("aria-labelledby", ctx_r1.ariaLabelledBy);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.getRootNode());
  }
}
function UiTreeComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26, 3);
    i0.ɵɵconditionalCreate(2, UiTreeComponent_Conditional_0_Conditional_5_Conditional_2_Template, 3, 2, "ul", 27);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("max-height", ctx_r1.scrollHeight);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.getRootNode() ? 2 : -1);
  }
}
function UiTreeComponent_Conditional_0_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.emptyMessageLabel, " ");
  }
}
function UiTreeComponent_Conditional_0_Conditional_6_Conditional_2_ng_template_0_Template(rf, ctx) {}
function UiTreeComponent_Conditional_0_Conditional_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTreeComponent_Conditional_0_Conditional_6_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 29);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyFilter);
  }
}
function UiTreeComponent_Conditional_0_Conditional_6_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 4);
  }
}
function UiTreeComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵconditionalCreate(1, UiTreeComponent_Conditional_0_Conditional_6_Conditional_1_Template, 1, 1)(2, UiTreeComponent_Conditional_0_Conditional_6_Conditional_2_Template, 1, 1, null, 29);
    i0.ɵɵtemplate(3, UiTreeComponent_Conditional_0_Conditional_6_ng_container_3_Template, 2, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.emptyMessageTemplate ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyMessageTemplate);
  }
}
function UiTreeComponent_Conditional_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTreeComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("drop", function UiTreeComponent_Conditional_0_Template_div_drop_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDrop($event));
    })("dragover", function UiTreeComponent_Conditional_0_Template_div_dragover_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDragOver($event));
    })("dragenter", function UiTreeComponent_Conditional_0_Template_div_dragenter_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDragEnter());
    })("dragleave", function UiTreeComponent_Conditional_0_Template_div_dragleave_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onDragLeave($event));
    });
    i0.ɵɵconditionalCreate(1, UiTreeComponent_Conditional_0_Conditional_1_Template, 3, 2, "div", 7);
    i0.ɵɵtemplate(2, UiTreeComponent_Conditional_0_ng_container_2_Template, 1, 0, "ng-container", 8);
    i0.ɵɵconditionalCreate(3, UiTreeComponent_Conditional_0_Conditional_3_Template, 5, 3, "div", 9);
    i0.ɵɵconditionalCreate(4, UiTreeComponent_Conditional_0_Conditional_4_Template, 4, 11, "p-scroller", 10);
    i0.ɵɵconditionalCreate(5, UiTreeComponent_Conditional_0_Conditional_5_Template, 3, 3, "div", 11);
    i0.ɵɵconditionalCreate(6, UiTreeComponent_Conditional_0_Conditional_6_Template, 4, 2, "div", 12);
    i0.ɵɵtemplate(7, UiTreeComponent_Conditional_0_ng_container_7_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(11, _c10, ctx_r1.selectionMode, ctx_r1.dragHover, ctx_r1.loading, ctx_r1.scrollHeight === "flex"))("ngStyle", ctx_r1.style);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loading ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.filter ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.virtualScroll ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.virtualScroll ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.loading && (ctx_r1.getRootNode() == null || ctx_r1.getRootNode().length === 0) ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate);
  }
}
function UiTreeComponent_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTreeComponent_Conditional_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i");
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap("p-tree-loading-icon pi-spin " + ctx_r1.loadingIcon);
  }
}
function UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "SpinnerIcon", 14);
  }
  if (rf & 2) {
    i0.ɵɵproperty("spin", true)("styleClass", "p-tree-loading-icon");
  }
}
function UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Conditional_1_1_ng_template_0_Template(rf, ctx) {}
function UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Conditional_1_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Conditional_1_1_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵtemplate(1, UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Conditional_1_1_Template, 1, 0, null, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.loadingIconTemplate);
  }
}
function UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Conditional_0_Template, 1, 2, "SpinnerIcon", 14);
    i0.ɵɵconditionalCreate(1, UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Conditional_1_Template, 2, 1, "span", 15);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(!ctx_r1.loadingIconTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loadingIconTemplate ? 1 : -1);
  }
}
function UiTreeComponent_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵconditionalCreate(1, UiTreeComponent_Conditional_1_Conditional_2_Conditional_1_Template, 1, 2, "i", 13);
    i0.ɵɵconditionalCreate(2, UiTreeComponent_Conditional_1_Conditional_2_Conditional_2_Template, 2, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loadingIcon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.loadingIcon ? 2 : -1);
  }
}
function UiTreeComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "table");
    i0.ɵɵelement(1, "ui-tree-node", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("node", ctx_r1.value[0])("root", true);
  }
}
function UiTreeComponent_Conditional_1_Conditional_4_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.emptyMessageLabel, " ");
  }
}
function UiTreeComponent_Conditional_1_Conditional_4_Conditional_2_ng_template_0_Template(rf, ctx) {}
function UiTreeComponent_Conditional_1_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiTreeComponent_Conditional_1_Conditional_4_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 29);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyFilter);
  }
}
function UiTreeComponent_Conditional_1_Conditional_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, null, 4);
  }
}
function UiTreeComponent_Conditional_1_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵconditionalCreate(1, UiTreeComponent_Conditional_1_Conditional_4_Conditional_1_Template, 1, 1)(2, UiTreeComponent_Conditional_1_Conditional_4_Conditional_2_Template, 1, 1, null, 29);
    i0.ɵɵtemplate(3, UiTreeComponent_Conditional_1_Conditional_4_ng_container_3_Template, 2, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.emptyMessageTemplate ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.emptyMessageTemplate);
  }
}
function UiTreeComponent_Conditional_1_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiTreeComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵtemplate(1, UiTreeComponent_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵconditionalCreate(2, UiTreeComponent_Conditional_1_Conditional_2_Template, 3, 2, "div", 31);
    i0.ɵɵconditionalCreate(3, UiTreeComponent_Conditional_1_Conditional_3_Template, 2, 2, "table");
    i0.ɵɵconditionalCreate(4, UiTreeComponent_Conditional_1_Conditional_4_Template, 4, 2, "div", 12);
    i0.ɵɵtemplate(5, UiTreeComponent_Conditional_1_ng_container_5_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c12, ctx_r1.selectionMode))("ngStyle", ctx_r1.style);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.loading ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.value && ctx_r1.value[0] ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.loading && (ctx_r1.getRootNode() == null || ctx_r1.getRootNode().length === 0) ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate);
  }
}
const _c13 = "@layer primeng{.p-tree-container{margin:0;padding:0;list-style-type:none;overflow:auto}.p-treenode-children{margin:0;padding:0;list-style-type:none}.p-tree-wrapper{overflow:auto}.p-treenode-selectable{cursor:pointer;-webkit-user-select:none;user-select:none}.p-tree-toggler{cursor:pointer;-webkit-user-select:none;user-select:none;display:inline-flex;align-items:center;justify-content:center;overflow:hidden;position:relative;flex-shrink:0}.p-treenode-leaf>.p-treenode-content .p-tree-toggler{visibility:hidden}.p-treenode-content{display:flex;align-items:center}.p-tree-filter{width:100%}.p-tree-filter-container{position:relative;display:block;width:100%}.p-tree-filter-icon{position:absolute;top:50%;margin-top:-.5rem}.p-tree-loading{position:relative;min-height:4rem}.p-tree .p-tree-loading-overlay{position:absolute;display:flex;align-items:center;justify-content:center;z-index:2}.p-tree-flex-scrollable{display:flex;flex:1;height:100%;flex-direction:column}.p-tree-flex-scrollable .p-tree-wrapper{flex:1}.p-tree .p-treenode-droppoint{height:4px;list-style-type:none}.p-tree .p-treenode-droppoint-active{border:0 none}.p-tree-horizontal{width:auto;padding-left:0;padding-right:0;overflow:auto}.p-tree.p-tree-horizontal table,.p-tree.p-tree-horizontal tr,.p-tree.p-tree-horizontal td{border-collapse:collapse;margin:0;padding:0;vertical-align:middle}.p-tree-horizontal .p-treenode-content{font-weight:400;padding:.4em 1em .4em .2em;display:flex;align-items:center}.p-tree-horizontal .p-treenode-parent .p-treenode-content{font-weight:400;white-space:nowrap}.p-tree.p-tree-horizontal .p-treenode{background:url(line.6fd2e298955ab301.gif) repeat-x scroll center center transparent;padding:.25rem 2.5rem}.p-tree.p-tree-horizontal .p-treenode.p-treenode-leaf,.p-tree.p-tree-horizontal .p-treenode.p-treenode-collapsed{padding-right:0}.p-tree.p-tree-horizontal .p-treenode-children{padding:0;margin:0}.p-tree.p-tree-horizontal .p-treenode-connector{width:1px}.p-tree.p-tree-horizontal .p-treenode-connector-table{height:100%;width:1px}.p-tree.p-tree-horizontal .p-treenode-connector-line{background:url(line.6fd2e298955ab301.gif) repeat-y scroll 0 0 transparent;width:1px}.p-tree.p-tree-horizontal table{height:0}.p-scroller .p-tree-container{overflow:visible}}.p-tree .p-tree-container .p-treenode .p-treenode-content{padding:0}.p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler{vertical-align:middle;display:inline-block;float:none;margin:0 .143em 0 0;color:var(--textColor);font-size:3em}.p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon{vertical-align:middle;display:inline-block;margin:0 .143em 0 0;color:var(--textColor)}.p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-label{margin:0;vertical-align:middle;display:inline-block}.p-tree .p-tree-container .p-treenode .p-treenode-content .p-treenode-icon+.p-treenode-label{margin-left:.143em}.p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox{margin:0 .5em 0 0}.p-tree .p-tree-container .p-treenode .p-treenode-content .p-checkbox .p-checkbox-icon{margin:1px 0 0}.p-tree .p-tree-container .p-treenode .p-treenode-content>span{line-height:inherit}.p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-dragover{background-color:var(--inputListItemHoverBgColor);color:var(--inputListItemHoverTextColor)}.p-tree .p-tree-container .p-treenode .p-treenode-children{padding-left:20px}.p-tree .p-tree-container .p-treenode-droppoint.p-treenode-droppoint-active{background-color:var(--highlightBgColor)}.p-tree.p-tree-horizontal{padding-left:0;padding-right:0}.p-tree.p-tree-horizontal .p-treenode .p-treenode-content{border:1px solid #c8c8c8;border-color:var(--panelContentBorderColor);background-color:var(--panelContentBgColor);color:var(--panelContentTextColor);padding:.571em 1em}.p-tree.p-tree-horizontal .p-treenode .p-treenode-content.p-highlight{background-color:var(--highlightBgColor);color:var(--highlightTextColor)}.p-tree.p-tree-horizontal .p-treenode .p-treenode-content .p-checkbox .ui-icon{color:var(--primaryColor)}.p-tree.p-tree-horizontal .p-treenode .p-treenode-content .p-treenode-label:not(.p-highlight):hover{background-color:inherit;color:inherit}.p-tree.p-tree-horizontal .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover{background-color:var(--inputListItemHoverBgColor);color:var(--inputListItemHoverTextColor)}ui-tree.static .p-tree-toggler{display:none!important}ui-tree.theme-text .p-tree .p-tree-container .p-treenode .p-treenode-content{font-size:.95rem}ui-tree.theme-text .p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable{color:var(--linkColor)}ui-tree.theme-text .p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover{color:var(--linkHoverColor)}ui-tree.theme-text .p-tree .p-tree-container ui-tree-node.is-root>.p-treenode>.p-treenode-content{font-size:1rem}ui-tree.theme-text .p-tree .p-tree-container ui-tree-node.is-root+ui-tree-node>.p-treenode{margin-top:6px}ui-tree.theme-menu .p-tree .p-tree-container .p-treenode{padding:.25em .1em .25em .3em}ui-tree.theme-menu .p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover{background-color:var(--inputListItemHoverBgColor);color:var(--inputListItemHoverTextColor)}\n";
export let UiTreeNode = /*#__PURE__*/(() => {
  class UiTreeNode extends UITreeNodeBase {
    constructor(tree) {
      super(tree);
    }
    getIcon() {
      const n = this.node;
      const isExpanded = n.expanded && n.children?.length;
      if (n.expandedIcon && isExpanded) {
        return n.expandedIcon;
      } else if (n.collapsedIcon && !isExpanded) {
        return n.collapsedIcon;
      } else if (n.icon) {
        return n.icon;
      }
      return "";
    }
    static {
      this.ɵfac = function UiTreeNode_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiTreeNode)(i0.ɵɵdirectiveInject(PARENT_TREE));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiTreeNode,
        selectors: [["ui-tree-node"]],
        hostVars: 2,
        hostBindings: function UiTreeNode_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("is-root", ctx.level === 0);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[1, "p-treenode-droppoint", 3, "ngClass"], ["role", "treeitem", 3, "ngClass", "ngStyle", "style"], [3, "class"], [1, "p-treenode-droppoint", 3, "drop", "dragover", "dragenter", "dragleave", "ngClass"], ["role", "treeitem", 3, "keydown", "ngClass", "ngStyle"], [1, "p-treenode-content", 3, "click", "contextmenu", "touchend", "drop", "dragover", "dragenter", "dragleave", "dragstart", "dragend", "draggable", "ngClass"], ["type", "button", "pRipple", "", "tabindex", "-1", "aria-hidden", "true", 1, "p-tree-toggler", "p-link", 3, "click"], [3, "styleClass"], ["aria-hidden", "true", 1, "p-checkbox", "p-component", 3, "ngClass"], [1, "p-treenode-icon", 3, "icon"], [1, "p-treenode-label"], ["role", "tree", 1, "p-treenode-children", 2, "display", "none", 3, "display"], ["role", "checkbox", 1, "p-checkbox-box", 3, "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["role", "tree", 1, "p-treenode-children", 2, "display", "none"], [3, "node", "parentNode", "firstChild", "lastChild", "index", "itemSize", "level"], [1, "p-treenode-connector"], [1, "p-treenode", 3, "ngClass"], ["tabindex", "0", 1, "p-treenode-content", 3, "click", "contextmenu", "touchend", "keydown", "ngClass"], [3, "ngClass"], [1, "p-treenode-children-container", 3, "display"], [1, "p-treenode-connector-table"], [3, "click", "ngClass"], [3, "styleClass", "ariaLabel"], [1, "p-treenode-children-container"], [1, "p-treenode-children"], [3, "node", "firstChild", "lastChild"]],
        template: function UiTreeNode_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UiTreeNode_Conditional_0_Template, 4, 4);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.node ? 0 : -1);
          }
        },
        dependencies: [UiTreeNode, CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, UiIconComponent, CheckIcon, ChevronDownIcon, ChevronRightIcon, MinusIcon, PlusIcon],
        styles: [_c13],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UiTreeNode;
})();
export let UiTreeComponent = /*#__PURE__*/(() => {
  class UiTreeComponent extends TreeBase {
    constructor() {
      super(...arguments);
      // NOTE: Custom templates are not functioning currently, 
      // must override + fix ngAfterContentInit for that.
      // see https://github.com/primefaces/prime-ng-old/blob/17.6.0/src/app/components/tree/tree.ts#L1167
      // TODO: #86c4wnx61 - Tree single-item highlighting is not working well in primeng 17 because selection change detection is f****d up.
      // TreeNodes will only check their selection status if their own changeDetection is triggered, they will then call tree.isSelected(self).
      // due to this, tree node deselection does not work, resulting in multiple highlights.
      // tree expansion is buggy too.
      this.cd2 = inject(ChangeDetectorRef);
      this.static = input(false, ...(ngDevMode ? [{
        debugName: "static"
      }] : /* istanbul ignore next */[])); // if true, expand/collapse will be hidden
      this.theme = input('menu', ...(ngDevMode ? [{
        debugName: "theme"
      }] : /* istanbul ignore next */[])); // menu theme uses block-like items, text appearance is more compact and entries look like text links
    }
    // TODO: click-to-expand mode
    updateTreeNodePath(path, matchBy, cb) {
      const nodesInPath = getTreeNodePath(this.value, path, matchBy);
      nodesInPath.forEach(node => {
        cb(node);
      });
      this.cd2.markForCheck();
    }
    deepFindNode(matcher) {
      return deepFindTreeNodeBy(this.value, matcher);
    }
    getPathToMatchingTreeNode(matcher) {
      return getPathToMatchingTreeNode(this.value, matcher);
    }
    updateTree(updateFn) {
      const newValue = updateFn(this.value) || this.value;
      const safeNewValue = [...newValue]; // in case updateFn mutated existing tree
      this.value = safeNewValue;
      this.cd2.detectChanges();
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵUiTreeComponent_BaseFactory;
        return function UiTreeComponent_Factory(__ngFactoryType__) {
          return (ɵUiTreeComponent_BaseFactory || (ɵUiTreeComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UiTreeComponent)))(__ngFactoryType__ || UiTreeComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiTreeComponent,
        selectors: [["ui-tree"]],
        hostVars: 6,
        hostBindings: function UiTreeComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("static", ctx.static())("theme-menu", ctx.theme() === "menu")("theme-text", ctx.theme() === "text");
          }
        },
        inputs: {
          static: [1, "static"],
          theme: [1, "theme"]
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: PARENT_TREE,
          useExisting: UiTreeComponent
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 2,
        consts: [["filter", ""], ["scroller", ""], ["treeNode", ""], ["wrapper", ""], ["emptyFilter", ""], [3, "ngClass", "ngStyle", "class"], [3, "drop", "dragover", "dragenter", "dragleave", "ngClass", "ngStyle"], [1, "p-tree-loading-overlay", "p-component-overlay"], [4, "ngTemplateOutlet"], [1, "p-tree-filter-container"], ["styleClass", "p-tree-wrapper", 3, "items", "tabindex", "style", "scrollHeight", "itemSize", "lazy", "options"], [1, "p-tree-wrapper", 3, "max-height"], [1, "p-tree-empty-message"], [3, "class"], [3, "spin", "styleClass"], [1, "p-tree-loading-icon"], ["type", "text", "autocomplete", "off", 1, "p-tree-filter", "p-inputtext", "p-component", 3, "keydown.enter", "input"], [3, "styleClass"], [1, "p-tree-filter-icon"], ["styleClass", "p-tree-wrapper", 3, "onScroll", "onScrollIndexChange", "onLazyLoad", "items", "tabindex", "scrollHeight", "itemSize", "lazy", "options"], ["pTemplate", "content"], ["pTemplate", "loader"], ["role", "tree", 1, "p-tree-container", 3, "ngClass", "style"], ["role", "tree", 1, "p-tree-container", 3, "ngClass"], [3, "level", "rowNode", "node", "firstChild", "lastChild", "index", "itemSize", "indentation"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "p-tree-wrapper"], ["role", "tree", 1, "p-tree-container"], [3, "node", "firstChild", "lastChild", "index", "level"], [3, "ngTemplateOutlet"], [3, "ngClass", "ngStyle"], [1, "p-tree-loading-mask", "p-component-overlay"], [3, "node", "root"]],
        template: function UiTreeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UiTreeComponent_Conditional_0_Template, 8, 16, "div", 5);
            i0.ɵɵconditionalCreate(1, UiTreeComponent_Conditional_1_Template, 6, 11, "div", 5);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.horizontal ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.horizontal ? 1 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, ScrollerModule, i2.Scroller, i3.PrimeTemplate, UiTreeNode],
        styles: [_c13],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return UiTreeComponent;
})();
export const UiTreeBundle = [UiTreeComponent, ...UiHeaderFooterBundle];